import Api from "./Api";
import Utils from "../utilities/Utils";
import { ProjectTag } from "../types";
import SearchHelper from "../helpers/SearchHelper";

export default class ProjectTagsController extends Api {
  static getProjectTags(params: object) {
    return fetch(`/api/project_tags?${SearchHelper.getQueryString(params)}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
    }).then((res) => res.json());
  }

  static create(projectTag: ProjectTag) {
    return fetch("/api/project_tags", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
      body: JSON.stringify({ project_tag: projectTag }),
    }).then((res) => res.json());
  }

  static update(projectTag: ProjectTag) {
    return fetch(`/api/project_tags/${projectTag.id}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
      body: JSON.stringify({ project_tag: projectTag }),
    }).then((res) => res.json());
  }

  static delete(id: string) {
    return fetch(`/api/project_tags/${id}`, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
    }).then((res) => res.json());
  }

  static getForm(params: object) {
    return fetch(`/api/project_tags/form?${Utils.encodeQueryData(params)}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
    }).then((res) => res.json());
  }
}
